import React, { useState } from 'react';
import { MailOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import './subcribe.css';
import { Outlet, useNavigate} from "react-router-dom";

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const items = [
  getItem('订阅中心', 'subscribe', <MailOutlined />, [
    getItem('舰船', 'ships'),
    // getItem('飞机', '/'),
    getItem('人物', 'persons'),
    getItem('设施目标', 'targets'),
    // getItem('事件', 'events'),
    // getItem('装备', '/'),
  ]),
];
const App = () => {
  const [current, setCurrent] = useState('ships');
  const navigate = useNavigate();
  const onClick = (e) => {
    setCurrent(e.key);
    const path = e.keyPath.reverse().join('/')
    navigate(`/${path}`)
  };

  const goToHome = () => {
    navigate('/')
  }
  return (
    <div className="sub">
      <div className="side-bar">
        <div className="sub-logo-style" onClick={goToHome}>OsintFusion</div>
        <Menu
            theme="dark"
            onClick={onClick}
            style={{
                width: 256,
                height: "100vh"
            }}
            defaultOpenKeys={['subscribe']}
            selectedKeys={[current]}
            mode="inline"
            items={items}
        />
      </div>
      <div id="detail">
        <Outlet />
      </div>
    </div>
  );
};
export default App;